module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_01-503487ed61685b5c2d9fb67ecc55bc9f.jpg";